export default "__VITE_ASSET__8225d54c__"